import React from 'react'
import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled'
import Image from 'next/image'
import TokensPng from '@/assets/imgs/staking/tokens.png'

const Text1 = styled(Typography)`
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0px 0px 40px #bfff0b;
  font-size: 54px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 5.4px;
`

const Banner = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        rowGap: 20,
        textAlign: { xs: 'center', md: 'unset' },
      }}
    >
      <Box sx={{ width: { xs: 'auto', md: 500 } }}>
        <Text1 variant="h1">Pool</Text1>
        <Typography sx={{ mt: 40, fontSize: '20px', fontWeight: 500 }}>
          Currently only supports mining of
          <span style={{ color: '#bfff0b' }}> ERC20 </span>
          tokens
        </Typography>
        <Typography sx={{ mt: 20, fontSize: '16px', fontWeight: 300 }}>
          Stake <span style={{ color: '#bfff0b' }}> $MUBI </span> to earn new tokens. Rewards are calculated per day.
        </Typography>
      </Box>

      <Box sx={{ minWidth: { xs: 342, md: 516 }, height: { xs: 228, md: 342 }, position: 'relative' }}>
        <Image src={TokensPng} fill alt="" />
      </Box>
    </Box>
  )
}

export default Banner
